// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import type { FlexProps } from '@iheartjane/reefer';
import { Flex } from '@iheartjane/reefer';
import type { ReactNode } from 'react';

import { useKioskSpacing } from '@jane/kiosk/hooks';

export interface HeaderProps extends FlexProps {
  backgroundColor?: string;
  children?: ReactNode;
  id?: string;
  sticky?: boolean;
}

const HeaderWrapper = ({ children, ...props }: HeaderProps) => {
  return <Flex {...props}>{children}</Flex>;
};

export const Header = styled(HeaderWrapper)(({
  theme,
  backgroundColor,
  pl,
  pr,
  px,
  pt,
  mb,
  pb,
  sticky,
}) => {
  const { getKioskSpacing } = useKioskSpacing();
  const paddingX = getKioskSpacing(64, 48);
  const paddingTop = getKioskSpacing(96, 56);
  const paddingBottom = getKioskSpacing(72, 56);
  const marginBottom = getKioskSpacing(48, 32);

  return {
    backgroundColor: backgroundColor ?? theme.colors.grays.ultralight,
    marginBottom: mb ?? marginBottom,
    paddingBottom: pb ?? paddingBottom,
    paddingLeft: pl ?? px ?? paddingX,
    paddingRight: pr ?? px ?? paddingX,
    paddingTop: pt ?? paddingTop,
    width: '100%',
    zIndex: 'var(--layers-header)',
    ...(sticky
      ? {
          left: 0,
          position: 'sticky' as const,
          right: 0,
          top: 0,
        }
      : {}),
  };
});

export const HeaderWithIcons = styled(Header)<{ signedIn: boolean }>(({
  signedIn,
}) => {
  const { getKioskSpacing, isIpad } = useKioskSpacing();

  return {
    alignItems: 'center',
    marginBottom: 0,
    paddingBottom: getKioskSpacing(40, 24),
    paddingTop: signedIn ? (isIpad ? 68 : 102) : getKioskSpacing(40, 24),
  };
});
